var React = require('react');

function BlackSagittarius (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"26.3254 14.1075 26.3254 2.0211 14.239 2.0211 14.239 5.6474 20.1344 5.6474 10.8003 14.9814 6.8459 11.027 4.2821 13.5908 8.2365 17.5461 2.0211 23.7616 4.5849 26.3254 10.8003 20.1099 14.7557 24.0644 17.3195 21.5006 13.3641 17.5452 22.6991 8.2112 22.6991 14.1075 26.3254 14.1075","fill":"#ebc192","strokeWidth":"0"}));
}

BlackSagittarius.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BlackSagittarius;

BlackSagittarius.default = BlackSagittarius;
